import { Component, OnInit } from '@angular/core';
import { Modal, overlayConfigFactory } from 'ngx-modialog';
import { switchMap } from 'rxjs/operator/switchMap';
import { map } from 'rxjs/operators';
import { ApiService } from '../../../utils/services/api.service';
import { FreeHotelModalComponent } from './free-hotel-modal/free-hotel-modal.component';
import { BSModalContext } from 'ngx-modialog/plugins/bootstrap';


@Component({
  selector: 'app-free-hotel-changes',
  templateUrl: './free-hotel-changes.component.html',
  styleUrls: ['./free-hotel-changes.component.scss']
})
export class FreeHotelChangesComponent implements OnInit {
  hotelChanges = [];
  lastHotels = []
  hotels = [];
  pendingIds = [];
  hotelsById = {};
  isLoading = false;

  constructor(private apiService: ApiService,public modal: Modal) { }

  ngOnInit() {
    this.getHotelChanges();
  }

  getHotelChanges() {
  this.isLoading = true;
    this.apiService.getHotelChanges().switchMap(hotelChangeResponse => {
      if(hotelChangeResponse){
        this.pendingIds = [];
        this.hotelChanges = hotelChangeResponse.data;
        this.hotelChanges.forEach(ids => {
          this.pendingIds.push(ids.hotelId)
        });
        return this.apiService.getHotelLast(this.pendingIds)
      }
     
    }).subscribe(hotelRes => {
      hotelRes.data.rows.forEach(hotel => {
        this.hotelsById[hotel.id] = hotel;
      });
      
      this.hotelChanges.forEach(changeItem => {
        changeItem.oldHotel = this.hotelsById[changeItem.hotelId];
      })
      
      this.isLoading = false;

    })
    
  }

  setApprove(hotelOrgId,hotelId, status) {
    let dialogRef = this.modal.open(
      FreeHotelModalComponent,
      overlayConfigFactory({
        size: 'md',
        hotelOrgId: hotelOrgId,
        hotelId:hotelId,
        status: status == 'reject' ? 'Rejected' : 'Accepted',
        isAgencyView: true
      }, BSModalContext));
    dialogRef.result.then((result) => {
      if (result) {
        result.forEach((response) => {
          if (response) {
            console.log('ozge')
          }
        });
      }
    });
  }

  


}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/free-hotel-changes/free-hotel-changes.component.ts